module.exports = __webpack_public_path__ + "img/reset.9bc128cf.svg";